import React, { useState } from 'react';
import { Button, Badge, TabContent, TabPane, Nav, Navbar, NavbarBrand, NavbarToggler, Collapse, NavItem, NavbarText, NavLink, Card, CardTitle, CardText, Row, Col } from 'reactstrap';
import logoADS from '../../assets/img/Autopartes-del-Sur--BlancoNew.png';
import './logo.scss';
import {CartContext} from '../../components/ParadigmaCartProvider/ParadigmaCartProvider.js';

const DefaultHeader = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const logout = () => props.logout != undefined && props.logout != null && props.logout();
  const showCarritoModal = ()=>props.showCarritoModal != undefined && props.showCarritoModal != null && props.showCarritoModal();
  return (
    <div id="body-header">
      <Navbar color="dark" dark className="bg-paradigma-black" expand="md">
        <div className="col col-2 my-auto">
          <div className="row">
            <div className="col-12 text-center">
              <a href="/">
                <img src={logoADS} alt="Logo Autopartes del Sur" className="img-fluid img-logo-autopartes-carrusel" />
              </a>
            </div>
          </div>
        </div>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="ml-auto pt-3" navbar>
            <CartContext.Consumer>
              {
                ({ selectedItems, quantity }) => {
                  return (
                    <React.Fragment>
                      <NavItem className="header-login-menu">
                        <NavLink className="py-0 px-2" onClick={showCarritoModal}>
                          <i style={{ fontSize: "30px", cursor:"Pointer" }} className="fa cui-cart"></i>
                          {selectedItems && selectedItems.length ? <Badge pill color="danger">{quantity()}</Badge> : null}
                        </NavLink>
                      </NavItem>
                    </React.Fragment>
                  );
                }
              }
            </CartContext.Consumer>
            <NavItem>
              <NavLink href="#/catalogo/" className="fontWeight600"><span className="text-secondary"><i className="fa fa-book" aria-hidden="true"></i></span>{" "}Catálogo</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="#/novedades/" className="fontWeight600"><span className="text-warning"><i className="fa fa-tag" aria-hidden="true"></i></span>{" "}Novedades</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="#/historialpedidos/" className="fontWeight600"><span className="text-secondary"><i className="fa fa-history" aria-hidden="true"></i></span>{" "}Historial de Pedidos</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="#/resumencuenta/" className="fontWeight600"><span className="text-secondary"><i className="fa fa-file-text" aria-hidden="true"></i></span>{" "}Resumen C.C.</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="#/perfil/" className="fontWeight600"><span className="text-secondary"><i className="fa fa-user-circle" aria-hidden="true"></i></span>{" "}Perfil</NavLink>
            </NavItem>
            <NavItem>
              <Button color="light" onClick={logout} className="fontWeight600"><i className="fa fa-sign-out" aria-hidden="true"></i> Salir</Button>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
}

export default DefaultHeader;



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultHeader.js